import React from 'react';
import { useSelector } from 'react-redux';
import * as call from '../../../../call';
import { IconColors, IconSizes, IconVariants } from '../../../constants';
import Icon from '../../Icon';
import ScreenShareIcon from '../../../assets/icons/screenshare.svg';
const ScreenShareControl = () => {
    const currentParticipant = useSelector(call.selectors.getCurrentParticipant);
    const isScreenSharing = currentParticipant?.streamType === call.constants.StreamType.Screen;
    if (!isScreenSharing) {
        return null;
    }
    return (<Icon size={IconSizes.Medium} variant={IconVariants.Plain} color={IconColors.Transparent}>
      <ScreenShareIcon />
    </Icon>);
};
export const ScreenShareControlKey = 'screen-share-control';
export default ScreenShareControl;
